import { connect } from 'kea'

import sceneLogic from '~/scenes/pages/request/logic'

const logic = connect({
  actions: [sceneLogic, ['toggleAvailability', 'setFlexibleAvailability']],
  props: [sceneLogic, ['availability', 'availabilityFlexible']]
})

export default logic
